<template>
  <div>
    <list row-key="id" ref="list" unit="领用统计" :query-params="params" item-name="Itsms" :layout="layout" size="small" show-summary :summary-method="summaryMethod"
      :show-query="showQuery" :get-data-func="getDataFunc" @reset="reset" :center-title="centerTitle">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="toPrint">打印</el-button>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="领用部门">
          <el-input v-model="DpName" class="long_inp" placeholder="请选择" @focus="openDpSelect" readonly />
        </el-form-item>
        <el-form-item label="领用仓库">
          <el-input v-model="WarehouseName" class="long_inp" placeholder="请选择" @focus="openWarehousePick" readonly />
        </el-form-item>
        <br>
        <el-form-item label="存货大类">
          <el-radio-group v-model="params.ProductTypeBigName" style="width: 390px;">
            <el-radio label="原材料">原材料</el-radio>
            <el-radio label="半成品">半成品</el-radio>
            <el-radio label="配件">配件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="原材料编码">
          <el-input v-model="ycl" class="long_inp" placeholder="请选择" @focus="openProductPick(1)" readonly />
        </el-form-item>
        <br>
        <el-form-item label="半成品编码">
          <el-input v-model="bcp" class="long_inp" placeholder="请选择" @focus="openProductPick(2)" readonly />
        </el-form-item>
        <el-form-item label="配件编码">
          <el-input v-model="pj" class="long_inp" placeholder="请选择" @focus="openProductPick(3)" readonly />
        </el-form-item>
        <br>
        <el-form-item label="领用日期" style="margin-right: 219px;">
          <el-date-picker class="range-picker" v-model="dateRange" type="daterange" range-separator="~" :clearable="false"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="onChange"
            style="width: 180px!important"></el-date-picker>
        </el-form-item>
        <el-form-item label="统计类型">
          <el-radio-group v-model="params.StatType">
            <el-radio :label="0">领用统计明细表</el-radio>
            <el-radio :label="1">领用统计汇总表</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocDate" label="领用日期" v-if="listStatType==0" >
          <template slot-scope="{row}">
            {{ $commonJs.toDateString(row.DocDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="ProductNo" :label="listTypeName+'代码'" />
        <el-table-column prop="ProductName" :label="listTypeName+'名称'" />
        <el-table-column prop="ColorName" label="颜色" />
        <el-table-column prop="WarehousePositionName" label="所在仓位" />
        <el-table-column prop="UnitName" label="单位" />
        <el-table-column prop="Quantity" label="领用数量" />
        <!-- <el-table-column prop="" label="折算单位" />
        <el-table-column prop="" label="折算数量" /> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <tree-select-dialog ref="dpTreeSelect" in-dialog @select-multiple="setDp" title="部门列表" key-id="DpId" key-name="部门名称" key-value="DpName"
      :func="dpApi.list" :default-value="dpArr" />
    <multi-pick-dialog ref="warehouseMultiPick" in-dialog @select-multiple="setWarehouse" title="仓库信息"
      key-id="WarehouseId" key-name="仓库编号" key-value="WarehouseName" :func="warehouseApi.list" second-name="仓库名称"
      second-value="WarehouseName" :default-value="warehouseArr" />
    <multi-pick-dialog ref="productyclMultiPick" in-dialog @select-multiple="setProductycl" title="原材料信息"
      key-id="ProductId" key-name="原材料编码" key-value="ProductNo" :func="proApi.list" :params="{}" second-name="原材料名称"
      second-value="ProductName" :default-value="yclArr" />
    <multi-pick-dialog ref="productbcpMultiPick" in-dialog @select-multiple="setProductbcp" title="半成品信息"
      key-id="ProductId" key-name="半成品编码" key-value="ProductNo" :func="proApi.list" :params="{}" second-name="半成品名称"
      second-value="ProductName" :default-value="bcpArr" />
    <multi-pick-dialog ref="productpjMultiPick" in-dialog @select-multiple="setProductpj" title="配件信息"
      key-id="ProductId" key-name="配件编码" key-value="ProductNo" :func="proApi.list" :params="{}" second-name="配件名称"
      second-value="ProductName" :default-value="pjArr" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/multiList";
import treeSelectDialog from '@/components/common/treeSelectDialog';
import multiPickDialog from '@/components/common/multiPickDialog';
export default {
  mixins: [listMixin],
  components: { list, treeSelectDialog, multiPickDialog },
  //关于multiPickDialog，keyId唯一Id，keyName/Value主要字段名称/值，func列表接口，params接口参数传对象，secondName/Value第二列名称/值，select-multiple选择后的回调，defaultValue已选回显
  //关于multiList，isMerge：true时三层布局，false时二层布局，itemName第二层数组名称，itemName2第三层数组名称，layout表格上方信息布局，
  data() {
    return {
      api: require("@/api/pr/prGetDoc").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      dpApi: require('@/api/ent/dp').default,
      saApi: require('@/api/sa/saOrder').default,
      unitApi: require('@/api/ba/tradeUnit').default,
      colorApi: require('@/api/ba/color').default,
      proApi: require('@/api/ba/product').default,
      params: {
        BusinessTypeNo: 9,
        WorkShopIds: [],
        SiteWarehouseIds: [],
        ProductTypeBigName: "原材料",
        ProductNos: [],
        StartDate: "",
        EndDate: "",
        StatType: 0,
      },
      dateRange: [],
      //---
      DpName: "",
      dpArr: [],
      //---
      WarehouseName: "",
      warehouseArr: [],
      //---
      ycl: "",
      yclArr: [],
      //---
      bcp: "",
      bcpArr: [],
      //---
      pj: "",
      pjArr: [],
      //---
      centerTitle: "",
      listTypeName: "",
      listStatType: 0,
    };
  },
  computed: {
    layout() {
      return [
        { name: "车间代码", key: "WorkShopNo", span: 6 },
        { name: "车间名称", key: "WorkShopName", span: 18 },
        { name: "仓库代码", key: "SiteWarehouseNo", span: 6 },
        { name: "仓库名称", key: "SiteWarehouseName", span: 18 },
      ];
    }
  },
  beforeMount() {
    this.reset();
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        let arr = this.yclArr.concat(this.bcpArr).concat(this.pjArr);
        if(arr.length) this.params.ProductNos = arr.map(x => { return x.ProductNo });
        else delete params.ProductNos;
        // this.listTypeName = params.ProductTypeBigName;
        // this.listStatType = params.StatType;
        // this.centerTitle = params.ProductTypeBigName + "领用统计" + (params.StatType==0?"明细表":"汇总表");
        // let Data = [];
        // Data = [
        //   { FullName: "张三", TradeUnitNo: "001", WorkShopName: "O001", Itsms: [{ BatchNo: "B001", ColorName: "红色", Quantity: 10 }, { BatchNo: "B002", ColorName: "绿色", Quantity: 20 }] },
        //   { FullName: "李四", TradeUnitNo: "002", WorkShopName: "O002", Itsms: [{ ColorName: "白色" }] },
        // ];
        // resolve({ Data });
        this.api.getPrGetStat({ ...params }).then((res) => {
          this.listTypeName = params.ProductTypeBigName;
          this.listStatType = params.StatType;
          this.centerTitle = params.ProductTypeBigName + "领用统计" + (params.StatType==0?"明细表":"汇总表");
          resolve(res);
        });
      });
    },
    openDpSelect() {
      this.$refs.dpTreeSelect.open();
    },
    openProductPick(type) {
      if(type == 1) this.$refs.productyclMultiPick.open();
      else if(type == 2) this.$refs.productbcpMultiPick.open();
      else this.$refs.productpjMultiPick.open();
    },
    openWarehousePick() {
      this.$refs.warehouseMultiPick.open();
    },
    openProductyclPick() {
      this.$refs.productyclMultiPick.open();
    },
    openProductbcpPick() {
      this.$refs.productbcpMultiPick.open();
    },
    openProductpjPick() {
      this.$refs.productpjMultiPick.open();
    },
    setDp(e,n,m) {
      this.dpArr = e;
      this.DpName = n;
      this.params.WorkShopIds = m;
    },
    setWarehouse(e, n, m) {
      this.warehouseArr = e;
      this.WarehouseName = n;
      this.params.SiteWarehouseIds = m;
    },
    setProductycl(e, n) {
      this.yclArr = e;
      this.ycl = n;
    },
    setProductbcp(e, n) {
      this.bcpArr = e;
      this.bcp = n;
    },
    setProductpj(e, n) {
      this.pjArr = e;
      this.pj = n;
    },
    onChange(e) {
      this.params.StartDate = e ? e[0] : "";
      this.params.EndDate = e ? e[1] : "";
    },
    reset() {
      let today = this.$commonJs.getToday();
      this.dateRange = [today.substr(0, 8) + "01", today];
      this.params.StartDate = today.substr(0, 8) + "01";
      this.params.EndDate = today;
      //----
      this.DpName = "";
      this.dpArr = [];

      this.WarehouseName = "";
      this.warehouseArr = [];

      this.ycl = "";
      this.yclArr = [];

      this.bcp = "";
      this.bcpArr = [];

      this.pj = "";
      this.pjArr = [];
    },
    summaryMethod(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '车间小计';
          return;
        } else if (index > 5) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = Math.floor(sums[index]);
          } else {
            sums[index] = '-';
          }
        } else {
          sums[index] = "-"
        }
      });
      return sums;
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          // var fields = list.tableList.map(x => x.tableName);
          // var params = { ...listParams, Fields: fields.join(',') };
          var params = { ...listParams };
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.exportPrGetStat(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    toPrint() {
      let list = this.$refs.list;
      let params = list.tempQueryParams;
      let type = 0;
      switch (params.ProductTypeBigName) {
        case "原材料":
          type = params.StatType==0?0:3;
          break;
        case "半成品":
          type = params.StatType==0?1:4;
          break;
        case "配件":
          type = params.StatType==0?2:5;
          break;
      }
      let path = "/receiveStatisticPrint?type=" + type;
      sessionStorage.setItem(path, JSON.stringify(list.data));
      let newpage = this.$router.resolve({ path });
      window.open(newpage.href, '_blank');
    },
  },
};
</script>
<style>
.long_inp .el-input__inner {
  width: 390px !important;
}
</style>